<div #parentDiv class="width375px">    
    <div #lowerLabel [ngClass]="{'lowerReadingLabelSelected': isSelected(1), 'lowerReadingLabel': !isSelected(1)}">{{getLowerReading()}}</div>
    <div #higherLabel [ngClass]="{'higherReadingLabelSelected': isSelected(2), 'higherReadingLabel': !isSelected(2)}">{{getHigherReading()}}</div>
    <canvas #bpcanvas></canvas>
</div>
<p class="summary2" *ngIf="undefined != getYesterday()">{{getYesterday()}} {{getYesterdayText()}}. </p>
<p class="summary2" *ngIf="undefined === getYesterday()">Did not log {{data.getName()}} {{getYesterdayText()}}. </p>